import React, {useState, useEffect} from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
  Badge,
  InputGroup,
  Modal,
} from "react-bootstrap";
import {
  FaWhatsapp,
  FaCheckCircle,
  FaExclamationTriangle,
  FaUsers,
  FaPhone,
  FaEnvelope,
  FaUser,
  FaIdCard,
  FaBuilding,
  FaArrowRight,
  FaShieldAlt,
} from "react-icons/fa";
import {useParams} from "react-router-dom";

const PublicSubscription = ({lists}) => {
  const {audienceId} = useParams();

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [audienceData, setAudienceData] = useState(null);
  const [formData, setFormData] = useState({
    phone: "",
    firstName: "",
    lastName: "",
    email: "",
    rut: "",
    organization: "",
  });
  const [errors, setErrors] = useState({});
  const [step, setStep] = useState(1); // 1: Verificar teléfono, 2: Completar datos, 3: Confirmación
  const [existingContact, setExistingContact] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // Simular carga de datos de la audiencia
  useEffect(() => {
    const loadAudienceData = async () => {
      try {
        // Aquí harías la llamada real a la API
        // const response = await fetch(`/api/audiences/${audienceId}`);
        // const data = await response.json();

        // Simulación de datos
        setTimeout(() => {
          const audience = (lists || []).find(
            (l) => l.id.toString() === audienceId
          );
          setAudienceData(audience);
          setLoading(false);
        }, 500);
      } catch (error) {
        console.error("Error loading audience data:", error);
        setLoading(false);
      }
    };

    if (audienceId) {
      loadAudienceData();
    }
  }, [audienceId, lists]);

  // Validar RUT chileno
  const validateRUT = (rut) => {
    if (!rut) return false;

    // Limpiar RUT
    const cleanRUT = rut.replace(/[^0-9kK]/g, "");
    if (cleanRUT.length < 8 || cleanRUT.length > 9) return false;

    const body = cleanRUT.slice(0, -1);
    const dv = cleanRUT.slice(-1).toLowerCase();

    let sum = 0;
    let multiplier = 2;

    for (let i = body.length - 1; i >= 0; i--) {
      sum += parseInt(body[i]) * multiplier;
      multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }

    const remainder = sum % 11;
    const calculatedDV =
      remainder < 2
        ? remainder.toString()
        : remainder === 10
        ? "k"
        : (11 - remainder).toString();

    return dv === calculatedDV;
  };

  // Formatear RUT
  const formatRUT = (value) => {
    const cleaned = value.replace(/[^0-9kK]/g, "");
    if (cleaned.length <= 1) return cleaned;

    const body = cleaned.slice(0, -1);
    const dv = cleaned.slice(-1);

    let formatted = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${formatted}-${dv}`;
  };

  // Formatear teléfono chileno
  const formatPhone = (value) => {
    const cleaned = value.replace(/\D/g, "");
    if (cleaned.startsWith("56")) {
      return cleaned;
    }
    if (cleaned.startsWith("9") && cleaned.length === 9) {
      return `56${cleaned}`;
    }
    return cleaned;
  };

  const handleInputChange = (field, value) => {
    let formattedValue = value;

    if (field === "rut") {
      formattedValue = formatRUT(value);
    } else if (field === "phone") {
      formattedValue = formatPhone(value);
    }

    setFormData((prev) => ({
      ...prev,
      [field]: formattedValue,
    }));

    // Limpiar error del campo
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: null,
      }));
    }
  };

  const validateStep1 = () => {
    const newErrors = {};

    if (!formData.phone) {
      newErrors.phone = "El número de teléfono es requerido";
    } else if (formData.phone.length < 11) {
      newErrors.phone =
        "Ingresa un número de teléfono válido (ej: +56912345678)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep2 = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "El nombre es requerido";
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "El apellido es requerido";
    }

    if (!formData.email.trim()) {
      newErrors.email = "El email es requerido";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Ingresa un email válido";
    }

    if (!formData.rut.trim()) {
      newErrors.rut = "El RUT es requerido";
    } else if (!validateRUT(formData.rut)) {
      newErrors.rut = "Ingresa un RUT válido";
    }

    if (!formData.organization.trim()) {
      newErrors.organization = "La organización es requerida";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleStep1Submit = async (e) => {
    e.preventDefault();

    if (!validateStep1()) return;

    setSubmitting(true);

    try {
      // Verificar si el contacto ya existe
      // const response = await fetch(`/api/contacts/check-phone`, {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ phone: formData.phone })
      // });

      // Simulación
      setTimeout(() => {
        const isExisting = Math.random() > 0.7; // 30% chance de ser existente

        if (isExisting) {
          setExistingContact({
            firstName: "Juan",
            lastName: "Pérez",
            email: "juan.perez@email.com",
            organization: "Transportes del Sur",
          });
          setFormData((prev) => ({
            ...prev,
            firstName: "Juan",
            lastName: "Pérez",
            email: "juan.perez@email.com",
            organization: "Transportes del Sur",
            rut: "12.345.678-9",
          }));
        }

        setStep(2);
        setSubmitting(false);
      }, 1500);
    } catch (error) {
      console.error("Error checking contact:", error);
      setSubmitting(false);
    }
  };

  const handleFinalSubmit = async (e) => {
    e.preventDefault();

    if (!validateStep2()) return;

    setSubmitting(true);

    try {
      // Enviar datos al backend
      // const response = await fetch(`/api/audiences/${audienceId}/subscribe`, {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(formData)
      // });

      // Simulación
      setTimeout(() => {
        setSubmitting(false);
        setShowSuccessModal(true);
      }, 2000);
    } catch (error) {
      console.error("Error subscribing:", error);
      setSubmitting(false);
    }
  };

  const handleSuccessClose = () => {
    setShowSuccessModal(false);
    // Redirigir a WhatsApp para iniciar conversación
    const whatsappMessage = encodeURIComponent(
      `¡Hola! Me acabo de suscribir a la lista "${audienceData?.name}". ¡Gracias!`
    );
    window.open(`https://wa.me/56912345678?text=${whatsappMessage}`, "_blank");
  };

  if (loading) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{minHeight: "100vh"}}
      >
        <div className="text-center">
          <Spinner animation="border" variant="primary" size="lg" />
          <p className="mt-3 text-muted">Cargando información...</p>
        </div>
      </Container>
    );
  }

  if (!audienceData) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{minHeight: "100vh"}}
      >
        <Alert variant="danger" className="text-center">
          <FaExclamationTriangle className="mb-2" size={48} />
          <h4>Lista no encontrada</h4>
          <p>
            La lista de suscripción que buscas no existe o ha sido eliminada.
          </p>
        </Alert>
      </Container>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "20px 0",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} xl={6}>
            {/* Header */}
            <div className="text-center text-white mb-4">
              <div className="mb-3">
                <FaWhatsapp
                  size={64}
                  className="text-success bg-white rounded-circle p-2"
                />
              </div>
              <h1 className="fw-bold mb-2">¡Únete a nuestra lista!</h1>
              <p className="lead opacity-90">
                Recibe comunicaciones importantes directamente en WhatsApp
              </p>
            </div>

            {/* Información de la audiencia */}
            <Card className="shadow-lg border-0 mb-4">
              <Card.Body className="p-4">
                <div className="d-flex align-items-center mb-3">
                  <FaUsers className="text-primary me-3" size={24} />
                  <div>
                    <h4 className="fw-bold mb-1">{audienceData.name}</h4>
                    <p className="text-muted mb-0">
                      {audienceData.description}
                    </p>
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center">
                    <FaBuilding className="text-muted me-2" />
                    <span className="text-muted">
                      {audienceData.organization}
                    </span>
                  </div>
                  <Badge bg="success" pill>
                    {audienceData.memberCount} miembros
                  </Badge>
                </div>
              </Card.Body>
            </Card>

            {/* Formulario de suscripción */}
            <Card className="shadow-lg border-0">
              <Card.Body className="p-4">
                {/* Indicador de pasos */}
                <div className="d-flex justify-content-center mb-4">
                  <div className="d-flex align-items-center">
                    <div
                      className={`rounded-circle d-flex align-items-center justify-content-center ${
                        step >= 1
                          ? "bg-primary text-white"
                          : "bg-light text-muted"
                      }`}
                      style={{width: "40px", height: "40px"}}
                    >
                      {step > 1 ? <FaCheckCircle /> : "1"}
                    </div>
                    <div
                      className={`mx-3 ${
                        step >= 2 ? "text-primary" : "text-muted"
                      }`}
                      style={{
                        width: "50px",
                        height: "2px",
                        backgroundColor: step >= 2 ? "#0d6efd" : "#dee2e6",
                      }}
                    ></div>
                    <div
                      className={`rounded-circle d-flex align-items-center justify-content-center ${
                        step >= 2
                          ? "bg-primary text-white"
                          : "bg-light text-muted"
                      }`}
                      style={{width: "40px", height: "40px"}}
                    >
                      {step > 2 ? <FaCheckCircle /> : "2"}
                    </div>
                  </div>
                </div>

                {step === 1 && (
                  <Form onSubmit={handleStep1Submit}>
                    <div className="text-center mb-4">
                      <h5 className="fw-bold">Ingresa tu número de WhatsApp</h5>
                      <p className="text-muted">
                        Verificaremos si ya tienes una cuenta con nosotros
                      </p>
                    </div>

                    <Form.Group className="mb-4">
                      <Form.Label className="fw-bold">
                        <FaPhone className="me-2 text-success" />
                        Número de WhatsApp
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>+56</InputGroup.Text>
                        <Form.Control
                          type="tel"
                          placeholder="912345678"
                          value={formData.phone.replace("56", "")}
                          onChange={(e) =>
                            handleInputChange("phone", `56${e.target.value}`)
                          }
                          isInvalid={!!errors.phone}
                          disabled={submitting}
                        />
                      </InputGroup>
                      {errors.phone && (
                        <Form.Control.Feedback type="invalid">
                          {errors.phone}
                        </Form.Control.Feedback>
                      )}
                      <Form.Text className="text-muted">
                        Debe ser el mismo número que usas en WhatsApp
                      </Form.Text>
                    </Form.Group>

                    <div className="d-grid">
                      <Button
                        type="submit"
                        variant="primary"
                        size="lg"
                        disabled={submitting}
                      >
                        {submitting ? (
                          <>
                            <Spinner
                              animation="border"
                              size="sm"
                              className="me-2"
                            />
                            Verificando...
                          </>
                        ) : (
                          <>
                            Continuar
                            <FaArrowRight className="ms-2" />
                          </>
                        )}
                      </Button>
                    </div>
                  </Form>
                )}

                {step === 2 && (
                  <Form onSubmit={handleFinalSubmit}>
                    <div className="text-center mb-4">
                      <h5 className="fw-bold">
                        {existingContact
                          ? "Confirma tus datos"
                          : "Completa tu información"}
                      </h5>
                      {existingContact ? (
                        <Alert variant="info" className="mt-3">
                          <FaCheckCircle className="me-2" />
                          ¡Encontramos tu información! Verifica que esté
                          correcta.
                        </Alert>
                      ) : (
                        <p className="text-muted">
                          Necesitamos algunos datos para completar tu
                          suscripción
                        </p>
                      )}
                    </div>

                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="fw-bold">
                            <FaUser className="me-2 text-primary" />
                            Nombre
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Tu nombre"
                            value={formData.firstName}
                            onChange={(e) =>
                              handleInputChange("firstName", e.target.value)
                            }
                            isInvalid={!!errors.firstName}
                            disabled={submitting}
                          />
                          {errors.firstName && (
                            <Form.Control.Feedback type="invalid">
                              {errors.firstName}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="fw-bold">Apellido</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Tu apellido"
                            value={formData.lastName}
                            onChange={(e) =>
                              handleInputChange("lastName", e.target.value)
                            }
                            isInvalid={!!errors.lastName}
                            disabled={submitting}
                          />
                          {errors.lastName && (
                            <Form.Control.Feedback type="invalid">
                              {errors.lastName}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-3">
                      <Form.Label className="fw-bold">
                        <FaEnvelope className="me-2 text-info" />
                        Email
                      </Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="tu@email.com"
                        value={formData.email}
                        onChange={(e) =>
                          handleInputChange("email", e.target.value)
                        }
                        isInvalid={!!errors.email}
                        disabled={submitting}
                      />
                      {errors.email && (
                        <Form.Control.Feedback type="invalid">
                          {errors.email}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className="fw-bold">
                        <FaIdCard className="me-2 text-warning" />
                        RUT
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="12.345.678-9"
                        value={formData.rut}
                        onChange={(e) =>
                          handleInputChange("rut", e.target.value)
                        }
                        isInvalid={!!errors.rut}
                        disabled={submitting}
                      />
                      {errors.rut && (
                        <Form.Control.Feedback type="invalid">
                          {errors.rut}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label className="fw-bold">
                        <FaBuilding className="me-2 text-success" />
                        Organización/Empresa
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Nombre de tu empresa"
                        value={formData.organization}
                        onChange={(e) =>
                          handleInputChange("organization", e.target.value)
                        }
                        isInvalid={!!errors.organization}
                        disabled={submitting}
                      />
                      {errors.organization && (
                        <Form.Control.Feedback type="invalid">
                          {errors.organization}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>

                    <Alert variant="success" className="mb-4">
                      <FaShieldAlt className="me-2" />
                      <strong>Tu privacidad es importante:</strong> Solo
                      usaremos esta información para enviarte comunicaciones
                      relevantes. Puedes darte de baja en cualquier momento.
                    </Alert>

                    <Row>
                      <Col>
                        <Button
                          variant="outline-secondary"
                          onClick={() => setStep(1)}
                          disabled={submitting}
                        >
                          Volver
                        </Button>
                      </Col>
                      <Col xs="auto">
                        <Button
                          type="submit"
                          variant="success"
                          size="lg"
                          disabled={submitting}
                        >
                          {submitting ? (
                            <>
                              <Spinner
                                animation="border"
                                size="sm"
                                className="me-2"
                              />
                              Suscribiendo...
                            </>
                          ) : (
                            <>
                              <FaWhatsapp className="me-2" />
                              ¡Suscribirme!
                            </>
                          )}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Modal de éxito */}
      <Modal show={showSuccessModal} onHide={handleSuccessClose} centered>
        <Modal.Body className="text-center p-5">
          <div className="mb-4">
            <FaCheckCircle size={64} className="text-success" />
          </div>
          <h3 className="fw-bold mb-3">¡Suscripción exitosa!</h3>
          <p className="text-muted mb-4">
            Te has suscrito exitosamente a <strong>{audienceData?.name}</strong>
            .
            <br />
            Ahora recibirás comunicaciones importantes en WhatsApp.
          </p>
          <div className="d-grid gap-2">
            <Button variant="success" size="lg" onClick={handleSuccessClose}>
              <FaWhatsapp className="me-2" />
              Abrir WhatsApp
            </Button>
            <Button
              variant="outline-secondary"
              onClick={() => setShowSuccessModal(false)}
            >
              Cerrar
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PublicSubscription;
